import React from 'react'
import PropTypes from 'prop-types'

import * as Styled from '../DeliveryBox.styles'

export const DeliveryEmailConfirm = ({ submitSuccess }) => {
  const confirmationMessage = "We'll contact you if the product is back in stock."
  const errorMessage = 'Sorry, there was a problem with submitting your email. Please try again later.'
  const alertKind = submitSuccess ? 'success' : 'error'
  return (
    <Styled.FufilmentEmailConfirmation kind={alertKind} isCloseable={false}>
      {submitSuccess ? confirmationMessage : errorMessage}
    </Styled.FufilmentEmailConfirmation>
  )
}

DeliveryEmailConfirm.propTypes = {
  /**
   * Required prop to pass for showing success on api call
   */
  submitSuccess: PropTypes.bool
}
